<div class="form-group" *ngIf="(progressAudioVal$ | async) > 0">
  <div class="progress">
    <div class="progress-bar" [style.width.%]="progressAudioVal$ | async">{{ progressAudioVal$ | async }}%</div>
  </div>
</div>
